module.exports = __webpack_public_path__ + "static/media/walls-construction.94b36388.png";